import request from "@/axios";
// 优惠券核销分页
export const get_coupon_writeoff = (params) => {
    return request({
        url: '/lebo-member/web/couponrecord/page',
        method: 'get',
        params
    });
};

// 优惠券管理本地分页
export const get_coupon_local = (params) => {
    return request({
        url: '/lebo-member/web/couponlocal/page',
        method: 'get',
        params
    });
};

// 优惠券管理线上分页
export const get_coupon = (params) => {
    return request({
        url: '/lebo-member/web/coupon/page',
        method: 'get',
        params
    });
};

// 新增优惠券管理
export const addCouponlocal = (data) => {
    return request({
        url: '/lebo-member/web/couponlocal/save',
        method: 'post',
        data
    })
}

// 编辑优惠券管理
export const editCouponlocal = (data) => {
    return request({
        url: '/lebo-member/web/couponlocal/update',
        method: 'post',
        data
    })
}

// 删除优惠券管理
export const deleteCouponlocal = (params) => {
    return request({
        url: '/lebo-member/web/couponlocal/remove',
        method: 'post',
        params
    })
}

// 详情
export const get_detail = (id) => {
    return request({
        url: `/lebo-member/web/couponlocal/detail/${id}`,
        method: 'get'
    });
};

/** 提交审核 */
export const auditSubmit = (id) => {
    return request({
      url: `/lebo-member/web/couponlocal/audit-submit/${id}`,
      method: 'put',
    })
}

/** 撤销审核 */
export const auditRecall = (id) => {
    return request({
      url: `/lebo-member/web/couponlocal/audit-recall/${id}`,
      method: 'put',
    })
}

/** 审核通过 */
export const auditPass = (id) => {
    return request({
      url: `/lebo-member/web/couponlocal/audit-pass/${id}`,
      method: 'put',
    })
}

/** 审核拒绝 */
export const auditReject = (id) => {
    return request({
      url: `/lebo-member/web/couponlocal/audit-reject/${id}`,
      method: 'put',
    })
}

// 所有优惠券
export const get_coupon_list = () => {
    return request({
        url: `/lebo-member/web/coupon/listAll`,
        method: 'get'
    });
};
